import React from 'react'
import {useParams} from 'react-router-dom'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import {get} from 'lodash'

const GET_DOWNLOAD_BY_CUID = gql`
  query GetDownloadByCuid($cuid: String!) {
    file(cuid: $cuid) {
      downloadUri
    }
  }
`

export default function DownloadFile() {
  const { cuid } = useParams()

  const { data } = useQuery(GET_DOWNLOAD_BY_CUID, {
    variables: {
      cuid
    },
    fetchPolicy: 'no-cache',
  })

  const downloadUri = get(data, 'file.downloadUri', null)
  if (downloadUri) {
    window.location = downloadUri
  }

  return (
    <>
      Starting download please wait...
    </>
  )
}

